export enum VettingType {
  Identity = 'IDENTITY',
  Standard = 'STANDARD',
  RCS = 'RCS',
  Authplus = 'AUTHPLUS',
  Asset = 'ASSET',
}

export enum FeatureType {
  Appeal = 'APPEALS',
}
